import React from 'react';
import Layout from 'components/Layout';

import SEO from 'components/SEO';
import Hero from 'views/home-new/Hero';
import Features from 'views/home-new/Features-new';
import Personas from 'views/home-new/Personas';
import Security from 'components/Security';
import EndingCta from 'components/EndingCta';

const Home = () => (
  <Layout>
    <Hero />
    <Features />
    <Security />
    <Personas />
    <EndingCta />
  </Layout>
);

export const Head = () => (
  <SEO
    title="Mudstack"
    description="Mudstack is the only asset management platform custom built for game studios and digital artists."
  />
);

export default Home;
